import {callApi} from './helpers'

export const loadPielikumi = (query) => (dispatch) => {
  return dispatch(callApi({
    viewName: 'pielikums_list',
    crudMethod: 'listPaging',
    crudParam: query
  }))
}